import styles from "./ChartContainer.module.css";

/**
 * Skeleton placeholders that match the shape of each widget so a
 * dashboard with a mix of types loads as a recognizable grid rather
 * than a wall of identical grey boxes.
 *
 * Each skeleton is a self-contained primitive — widget renderers pick
 * the one whose footprint matches their final layout.
 */

export function NumberSkeleton() {
  return <div className={styles.skeletonNumber} />;
}

export function ChartSkeleton({ minHeight = 220 }: { minHeight?: number }) {
  return <div className={styles.skeletonChart} style={{ minHeight }} />;
}

export function BarSkeleton({ minHeight = 200 }: { minHeight?: number }) {
  return <div className={styles.skeletonBar} style={{ minHeight }} />;
}

export function HeatmapSkeleton({ minHeight = 160 }: { minHeight?: number }) {
  return <div className={styles.skeletonHeatmap} style={{ minHeight }} />;
}

export function TableSkeleton({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className={styles.skeletonRow}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div key={colIndex} className={styles.skeletonCell} />
          ))}
        </div>
      ))}
    </div>
  );
}
